import { Text } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { t } from "i18next";
import { CraColoringAttribute } from "./CraColoringAttribute";
import { CraColoringScore } from "./CraColoringScore";
import { CraColoringTreatment } from "./CraColoringTreatment";
import { useMemo } from "react";
import { CraAttributes } from "@keita/lanepatrol-sdk";
import { CraColoring, CraColoringType } from "../../../../map/models/CraColoring";
import { tScoreType } from "../../../../coding/utils/score-utils";
import { CraAttributeUtils } from "../../../../coding/utils/attribute-utils";

interface Props {
  craColoring: CraColoring;
}

const CraColoringLegendBase: React.FC<Props> = ({ craColoring }) => {
  const [text, content] = useMemo(() => {
    switch (craColoring.type) {
      case CraColoringType.Score:
        return [tScoreType(craColoring.scoreKey), <CraColoringScore />];
      case CraColoringType.Treatment:
        return [
          t(`sdk:treatments.${craColoring.treatmentType}`),
          <CraColoringTreatment />,
        ];
      case CraColoringType.Attribute:
        const attribute = CraAttributes.getByName(
          craColoring.attributeName
        )!;
        return [
          CraAttributeUtils.getLabel(craColoring.attributeName),
          <CraColoringAttribute attribute={attribute} />,
        ];
    }
  }, [craColoring]);

  return (
    <>
      <Text fontSize="sm" fontWeight="semibold">
        {text}
      </Text>
      {content}
    </>
  );
};

export const CraColoringLegend = observer(CraColoringLegendBase);
